"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImplementationSnippetsClient = void 0;
const tslib_1 = require("tslib");
const authenticated_client_1 = require("./authenticated.client");
class ImplementationSnippetsClient extends authenticated_client_1.AuthenticatedClient {
    constructor() {
        super(...arguments);
        this.basePath = '/v1/implementation-snippets';
    }
    create(snippet) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(this.basePath, snippet);
            return response.payload;
        });
    }
    delete(snippetId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpDelete(`${this.basePath}/${snippetId}`);
            return response.payload;
        });
    }
    update({ snippetId, snippet, }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPut(`${this.basePath}/${snippetId}`, snippet);
            return response.payload;
        });
    }
    search(searchParameters) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const queryParams = this.getQueryString(searchParameters);
            const response = yield this.httpGet(`${this.basePath}/?${queryParams}`);
            return response.payload;
        });
    }
}
exports.ImplementationSnippetsClient = ImplementationSnippetsClient;
//# sourceMappingURL=implementation-snippets.client.js.map